module.exports = [
  {
    title: 'Home',
    url: '/',
  },
  {
    title: 'Menu',
    url: '/menu',
  },
  {
    title: 'Contact Us',
    url: '/contact-us',
  },
];
